// @ts-check
import React from "react"
import { SKELETON_ROW_COUNT } from "../utils/table.constants"
import { TableCellSkeleton } from "./cells/TableCellSkeleton.component"

/**
 * @param {import("./TableBodyLoading.component.types").TableBodyLoadingProps} props
 */
export const TableBodyLoading = (props) => {
  const { table } = props

  const columns = table.getVisibleLeafColumns()

  const virtualItems = Array.from({ length: SKELETON_ROW_COUNT }).map(
    (_, index) => ({
      index,
    })
  )

  return (
    <tbody className="table__body table__body--loading">
      {virtualItems.map((virtualRow) => {
        return (
          <tr
            key={`skeleton-${virtualRow.index}`}
            className="table__body-row table__body-row--loading"
          >
            {columns.map((column) => (
              <TableCellSkeleton key={column.id} column={column} />
            ))}
          </tr>
        )
      })}
    </tbody>
  )
}
